<template>
  <div>
    <el-form-item label="原始参数名称">
      <el-input v-model="ruleForm.dataName" @change="updateData"></el-input>
    </el-form-item>
    <div v-for="(rule,index) in ruleForm.rules" :key="index">
      <el-form-item :label="'比较的数字'+(index+1)" >
        <el-input v-model="rule.compareTo" @change="updateData"></el-input>
      </el-form-item>
      <el-form-item :label="'比较运算符'+(index+1)">
        <el-select v-model="rule.operation" placeholder="请选择" @change="updateData">
          <el-option v-for="item in integerOperators" :key="item.value" :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="'比较关系'+(index+1)">
        <el-select v-model="rule.logicalRelation" @change="updateData">
          <el-option v-for="item in logicalOperators" :key="item.value" :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </el-form-item>
    </div>
    <div style="text-align: right;color: #e2efff" >
      <el-link type="primary" @click="addRule">添加规则<i class="el-icon-circle-plus-outline el-icon--right"></i></el-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntegerRule",
  props: {
    rule: {
      type: Object,
      default() {
        return {
          dataName: "",
          rules: [
            {compareTo: "", operation: "", logicalRelation: "",}
          ]
        }
      }
    }
  },
  data() {
    return {
      integerOperators: [
        {label: '等于', value: 'eq'},
        {label: '不等于', value: 'neq'},
        {label: '大于', value: 'gth'},
        {label: '小于', value: 'sth'},
      ],
      logicalOperators: [
        {label: '和', value: 'AND'},
        {label: '或', value: 'OR'}
      ],
      ruleForm: this.rule,
    }
  },
  methods: {
    addRule(){
      this.ruleForm.rules.push({compareTo: "", operation: "", logicalRelation: "",})
    },
    updateData() {
      this.$emit("change", this.ruleForm)
    }
  }
}
</script>

<style scoped>

</style>
